import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setActiveAssetReportExcelData, setActiveAssetReportGridData, setIsReportGridDataLoading,setActiveAssetReportDropdownGridData } from 'Store/AssetManagement/ActiveAssetReport/ActiveAssetReportAction';
import { GET_ACTIVE_ASSET_REPORT_EXCEL_DATA, GET_ACTIVE_ASSET_REPORT_GRID_DATA,GET_ACTIVE_ASSET_REPORT_DROPDOWN_GRID_DATA } from 'Store/AssetManagement/ActiveAssetReport/ActiveAssetReportType';


function* getActiveAssetReportExcelSaga(req?: any): any {
    try {
        yield put(globalLoaderText("Exporting Excel...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/report/excel`,
            apiMethod: apiMethod.POST,
            payload: req?.payload
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setActiveAssetReportExcelData({ response: response, status: "success" }))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setActiveAssetReportExcelData({ response: {}, status: "failed" }))
    }
}

function* getActiveAssetReportGridSaga(req?: any): any {
    try {
        yield put(setIsReportGridDataLoading(true));
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/report`,
            apiMethod: apiMethod.POST,
            payload: req?.payload
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setIsReportGridDataLoading(false));
        yield put(setActiveAssetReportGridData({ response: response, status: "success" }))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setIsReportGridDataLoading(false));
        yield put(setActiveAssetReportGridData({ response: {}, status: "failed" }))
    }
}

function* getActiveAssetReportDropdownGridSaga () : any {
    try {
        yield put(setIsReportGridDataLoading(true));
        yield put(globalLoaderText("Fetching Dropdown Data...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/report/dropdown`,
            apiMethod: apiMethod.GET,
            payload : {}
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setIsReportGridDataLoading(false));
        yield put(setActiveAssetReportDropdownGridData({ response: response, status: "success" }))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setIsReportGridDataLoading(false));
        yield put(setActiveAssetReportDropdownGridData({ response: {}, status: "failed" }))
    }
}

function* watchCreateAssement() {
    yield takeEvery(GET_ACTIVE_ASSET_REPORT_EXCEL_DATA, getActiveAssetReportExcelSaga)
    yield takeLatest(GET_ACTIVE_ASSET_REPORT_GRID_DATA, getActiveAssetReportGridSaga)
    yield takeEvery(GET_ACTIVE_ASSET_REPORT_DROPDOWN_GRID_DATA, getActiveAssetReportDropdownGridSaga)
}

export default function* combinedSaga() {
    yield all([
        watchCreateAssement()
    ])
}